"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ParamDictionary {
    constructor() {
        this.keys = [];
        this.values = {};
        this.m = {};
    }
    set(key, param, unknown = false) {
        this.keys.push(key);
        unknown ? this.m[':' + key] = param : this.values[':' + key] = param;
    }
    get(key) {
        return this.m.hasOwnProperty(':' + key) ? this.m[':' + key] : this.values[':' + key];
    }
    map(fn) {
        for (const key of this.keys) {
            const d = this.get(key);
            if (d) {
                fn(key, d);
            }
        }
    }
}
exports.default = ParamDictionary;
